import * as yup from "yup";

export interface ClinicApiKeyResource {
  apiKey: string;
  lastUsedAt: string | null;
  createdAt: string;
}

export const clinicApiKeyResourceSchema = yup.object({
  apiKey: yup.string().required(),
  lastUsedAt: yup.string().nullable().defined(),
  createdAt: yup.string().required(),
});
